import React from "react";
import { logout } from "src/constants/global-const"; //M10-15057

const RestrictedPage: React.FC = () => {

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold text-red-600">Access Restricted</h1>
        <p className="mb-8 text-xl text-gray-700">Sorry, you don't have permission to access this page.</p>
        {/* M10-15057 */}
        <button
          className="px-6 py-2 font-semibold text-white bg-red-600 rounded hover:bg-red-700"
          onClick={() => logout(false)}
        >
          Logout
        </button>
        {/* M10-15057 */}
      </div>
    </div>
  );
};

export default RestrictedPage;
